export const activeSubPath = (fullPath, subpath) => {
  const basePath = fullPath.split(`/${subpath}/`);
  const postfixPath = basePath.length > 1 ? `/${basePath[1].split('/')[0]}` : '';
  return `${basePath[0]}/${subpath}${postfixPath}`;
};



// WEBPACK FOOTER //
// ./src/utilities/routes.js